module.exports = __webpack_public_path__ + "img/dsCircleBack.94c3bb12.svg";